import { Activity } from "../models/Activity";
import ApiService from "./ApiService";

export default class ActivityService {
  public static getActivityList(): Promise<Activity[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/activities`, "")
        .then((result) => {
          if (!result.data) {
            resolve([] as Activity[]);
          } else {
            const retVal: Activity[] = [];
            result.data.forEach((item: any) => {
              const dataItem = { ...item } as Activity;
              let exist = false;
              retVal.forEach((x) => {
                if (x.Value === dataItem.Value || exist) {
                  exist = true;
                }
              });
              if (!exist) {
                retVal.push(dataItem);
              }
            });
            resolve(retVal);
          }
        })
        .catch((error) => reject(error));
    });
  }

  public static addNew(value: string, defaultTechnology = "", iconClass = ""): Promise<Activity> {
    return new Promise((resolve, reject) => {
      const item = { Value: value, DefaultTechnology: defaultTechnology, IconClass: iconClass } as Activity;
      ApiService.post(`/activities`, item).then((result) => {
        if (result.data) {
          resolve(result.data);
        }
      });
    });
  }

  public static update(activity: Activity): Promise<Activity> {
    return new Promise((resolve, reject) => {
      ApiService.put(`/activities`, activity).then((result) => {
        if (result.data) {
          resolve(result.data);
        }
      });
    });
  }
}
